import API_URLS from '@Constants/apiUrls.constants';
import { CommonConstants } from '@Constants/index';
import { GetLists } from '@Models/common.models';
import {
  GlobalScriptsMutationResponse,
  GlobalDeleteScripts,
  GlobalScriptsListResponse,
  GlobalScriptResponse,
  GlobalScriptAdd,
  GlobalScriptEdit,
} from '@Models/scripts.models';
import query from '@Utils/common/query.utils';

import { baseApi } from './baseApi.service';

export const globalScriptsApi = baseApi
  .enhanceEndpoints({
    addTagTypes: ['GlobalScripts', 'GlobalScript', 'Scripts', 'Script'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      /** Fetch scripts list with given queries */
      getGlobalScriptsLists: builder.query<GlobalScriptsListResponse, GetLists>(
        {
          query: ({ data: { direction, ...resData }, isArchive = false }) =>
            `${API_URLS.GLOBAL_SCRIPTS}${isArchive ? '?archive&' : '?'}${
              direction || CommonConstants.INITIAL_SORT_DIRECTION
            }&${query.stringify({ ...resData })}`,
          providesTags: ['GlobalScripts'],
        }
      ),
      /** Fetch script with given id */
      getGlobalScript: builder.query<GlobalScriptResponse, string>({
        query: (id) => `${API_URLS.GLOBAL_SCRIPTS}/${id}`,
        providesTags: ['GlobalScript'],
      }),
      /** Delete the script with the given id */
      deleteGlobalScripts: builder.mutation<
        GlobalScriptsMutationResponse,
        GlobalDeleteScripts
      >({
        query: (body) => ({
          url: `${API_URLS.GLOBAL_SCRIPTS}/delete`,
          method: 'PUT',
          body,
        }),
        invalidatesTags: ['GlobalScripts', 'Scripts', 'Script'],
      }),
      /** Add new script */
      addGlobalScript: builder.mutation<GlobalScriptResponse, GlobalScriptAdd>({
        query: (body) => ({
          url: `${API_URLS.GLOBAL_SCRIPTS}`,
          method: 'POST',
          body,
        }),
        invalidatesTags: ['GlobalScript', 'GlobalScripts', 'Scripts', 'Script'],
      }),
      /** Edit the script with the given id */
      editGlobalScript: builder.mutation<
        GlobalScriptResponse,
        GlobalScriptEdit
      >({
        query: (body) => ({
          url: `${API_URLS.GLOBAL_SCRIPTS}/${body.id}`,
          method: 'PUT',
          body,
        }),
        invalidatesTags: ['GlobalScript', 'GlobalScripts', 'Scripts', 'Script'],
      }),
    }),
  });

export const {
  useGetGlobalScriptsListsQuery,
  useGetGlobalScriptQuery,
  useDeleteGlobalScriptsMutation,
  useAddGlobalScriptMutation,
  useEditGlobalScriptMutation,
} = globalScriptsApi;
